<div class="d-flex justify-content-between">
  <div style="width: 78%">
    <div class="head-title mb-2">
      <!-- Lưu ý -->
      <p class="title-explain w-100 m-0">* {{ 'keo_tha_hinh_anh_de_thay_doi_thu_tu' | translate }}</p>
    
      <div class="p-0 m-0 d-flex align-items-center justify-content-center w-100">
        <!-- Chọn thiết bị -->
        <div class="device">
          <div *ngIf="subproject.desktop_template_display && subproject.style != 'app'" class="icon-field p-2" role="button"
            [class.active]="device == 'desktop'" (click)="device = 'desktop'">
            <span nz-icon [nzType]="'desktop'" nzTheme="outline" data-toggle="tooltip" [title]="'desktop'"
              nz-tooltip nzTooltipTitle="{{'may_tinh' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="device == 'tablet_landscape'" (click)="device = 'tablet_landscape'">
            <span nz-icon style="transform: rotate(90deg); scale: 1.2" [nzType]="'tablet'" nzTheme="outline"
              data-toggle="tooltip" [title]="'tablet'" nz-tooltip
              nzTooltipTitle="{{'may_tinh_bang_ngang' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.tablet_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="device == 'tablet_portrait'" (click)="device = 'tablet_portrait'">
            <span nz-icon style="scale: 1.2" [nzType]="'tablet'" nzTheme="outline" data-toggle="tooltip"
              [title]="'tablet'" nz-tooltip nzTooltipTitle="{{'may_tinh_bang_doc' | translate}}"
              nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_landscape_template_display" class="icon-field p-2" role="button"
            [class.active]="device == 'mobile_landscape'" (click)="device = 'mobile_landscape'">
            <span nz-icon style="transform: rotate(90deg)" [nzType]="'mobile'" nzTheme="outline"
              data-toggle="tooltip" [title]="'mobile'" nz-tooltip
              nzTooltipTitle="{{'dien_thoai_ngang' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
          <div *ngIf="subproject.mobile_portrait_template_display" class="icon-field p-2" role="button"
            [class.active]="device == 'mobile_portrait'" (click)="device = 'mobile_portrait'">
            <span nz-icon [nzType]="'mobile'" nzTheme="outline" data-toggle="tooltip" [title]="'mobile'" nz-tooltip
              nzTooltipTitle="{{'dien_thoai_doc' | translate}}" nzTooltipPlacement="bottom"></span>
          </div>
        </div>
      </div>
      
      <div class="p-0 m-0 d-flex align-items-center justify-content-end w-100">
        <!-- Nếu ảnh chứa id_subproject thì đã là ảnh trên server rồi nên sẽ ẩn -->
        <button *ngIf="hasSomeImgNotIncludeIdSubproject()" class="upload-background-image mr-0" (click)="isShowConfirmPopup = true">
          {{'chuyen_anh_len_server' | translate}}
        </button>
      </div>
    </div>
    
    <!-- Phần chọn option và nguồn để tải ảnh lên -->
    <div class="d-flex align-items-center" style="gap: 12px">
      <!-- Phần chọn sử dụng hình ảnh thêm là riêng cho 1 thiết bị hay dùng chung cho 5 thiết bị -->
      <div class="d-flex w-50 justify-content-between align-items-center my-1">
        <span>{{ 'anh_dung_chung_cho_cac_thiet_bi' | translate }}</span>
        <nz-switch [(ngModel)]="isSharedImg"></nz-switch>
      </div>
    
      <!-- Phần chọn nguồn ảnh -->
      <mat-form-field appearance="fill" class="config-img w-100">
        <mat-label>{{'nguon_hinh_anh_hien_thi_len' | translate}}</mat-label>
        <mat-select disableRipple [(ngModel)]="sourceImg">
          <mat-option *ngFor="let source of sources" [value]="source.value">
            {{source.label | translate}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    
      <ng-container *ngIf="sourceImg == 'device'">
        <!-- Phần lựa chọn nén ảnh -->
        <mat-form-field appearance="fill" class="config-img w-100"
        >
          <mat-label>{{'nen_anh_tai_len' | translate}}</mat-label>
          <mat-select disableRipple [(ngModel)]="compressType">
            <mat-option [value]="'no-compress'">{{'khong_nen_anh_sau_khi_tai_len' | translate}}</mat-option>
            <mat-option [value]="'compress-frame'">{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}</mat-option>
            <mat-option [value]="'custom'">{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}</mat-option>
          </mat-select>
        </mat-form-field>
      
        <ng-container *ngIf="compressType == 'custom'">
          <!-- Phần chọn kích thước nén ảnh nếu lựa chọn nén theo kích thước tự chọn -->
          <mat-form-field class="w-50 mr-0">
            <mat-label>{{'chieu_rong' | translate}}</mat-label>
            <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
          </mat-form-field>
        
          <mat-form-field class="w-50">
            <mat-label>{{'chieu_cao' | translate}}</mat-label>
            <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
          </mat-form-field>
        </ng-container>
      </ng-container>
    </div>
    
    <!-- Phần modal chuyển ảnh lên server -->
    <nz-modal nzTitle="{{ 'chuyen_anh_len_server' | translate}}" [(nzVisible)]="isShowConfirmPopup" [nzContent]="modalContent"
      (nzOnCancel)="isShowConfirmPopup = false;" (nzOnOk)="handleOkConfirm()" [nzFooter]="modalFooter">
      <ng-template #modalContent>
        <p>{{'nen_anh_tai_len' | translate}}</p>
        <nz-select style="margin-bottom: 15px" [(ngModel)]="compressType"
          nzPlaceHolder="{{'nen_anh_tai_len' | translate}}" nzAllowClear>
          <nz-option [nzValue]="'no-compress'" nzLabel="{{'khong_nen_anh_sau_khi_tai_len' | translate}}"></nz-option>
          <nz-option [nzValue]="'compress-frame'" nzLabel="{{'nen_anh_theo_ti_le_khung_hien_thi_anh' | translate}}"></nz-option>
          <nz-option [nzValue]="'custom'" nzLabel="{{'nen_anh_theo_kich_thuoc_tu_chon' | translate}}"></nz-option>
        </nz-select>
    
        <ng-container *ngIf="compressType == 'custom'">
          <mat-form-field class="mr-4">
            <mat-label>{{'chieu_rong' | translate}}</mat-label>
            <input matInput placeholder="{{'chieu_rong' | translate}}" [(ngModel)]="compressWidth">
          </mat-form-field>
      
          <mat-form-field>
            <mat-label>{{'chieu_cao' | translate}}</mat-label>
            <input matInput placeholder="{{'chieu_cao' | translate}}" [(ngModel)]="compressHeight">
          </mat-form-field>
        </ng-container>
      </ng-template>
      <ng-template #modalFooter>
        <button nz-button nzType="default" (click)="isShowConfirmPopup = false;">{{'khong' | translate}}</button>
        <button nz-button nzType="primary" (click)="handleOkConfirm()" [nzLoading]="isConfirmLoading">{{'dong_y' | translate}}</button>
      </ng-template>
    </nz-modal>
    
    
    <!-- Phần danh sách hình ảnh - Có thể nắm kéo thả ngang để thay đổi thứ tự của danh sách hình ảnh -->
    <div cdkDropList (cdkDropListDropped)="cdkDropListDropped($event)" class="image-list" [cdkDropListData]="dataImages"
    cdkDropListOrientation="horizontal" #scrollList>
      <div *ngFor="let img of dataImages; let i = index" cdkDrag class="image-item my-1" [draggable]="true">
        <div class="image-item__info">
          <div class="image-img__wrapper transparency-grid">
            <img [src]="img" class="image-img" />
          </div>
          <!-- Tên ảnh và icon copy link ảnh -->
          <p class="image-item__info-text" (click)="copyLinkImg(img)"
          nz-tooltip nzTooltipPlacement="bottom"
          nzTooltipTitle="{{'nhan_chuot_de_sao_chep_duong_dan_anh_nay_vao_bo_nho_tam' | translate}}">
            {{ getFileInfo(img).fullFileName }} 
            <mat-icon>content_copy</mat-icon>
          </p>
        </div>
        <div class="gr-btn">
          <div class="gr-btn__status">
            <button *ngIf="!img.includes(id_subproject)" class="gr-btn__button"
            nz-tooltip nzTooltipTitle="{{'anh_chua_duoc_day_len_server_hoac_anh_bi_chan_day_len_server' | translate}}">
              <mat-icon class="gr-btn__button-icon">warning</mat-icon>
            </button>
          </div>
          <div class="gr-btn__action">
            <button class="gr-btn__button" (click)="removeImage(i)">
              <mat-icon class="gr-btn__button-icon">close</mat-icon>
            </button>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Phần kéo thả ảnh từ bên ngoài vào -->
    <div *ngIf="sourceImg == 'device'"
    class="drop-zone mt-4"
    [class.dragging]="dragging"
    (drop)="onFileDropped_upload($event)"
    (dragover)="onDragOver_upload($event)"
    (dragleave)="onDragLeave_upload()">
      <label *ngIf="!previewUrl" for="upload">
        <mat-icon>image</mat-icon>
        <p>{{ 'keo_hinh_anh_vao_day_hoac' | translate }} <span>{{ 'tai_tep_len' | translate }}</span></p>
      </label>
    
      <div *ngIf="previewUrl" class="preview">
        <img [src]="previewUrl" alt="Preview" />
      </div>
    
      <div *ngIf="previewUrl" class="button-list">
        <button (click)="openUpload()">
          <mat-icon>{{ iconAddImage[sourceImg] }}</mat-icon>
        </button>
        <button (click)="previewUrl = ''">
          <mat-icon>close</mat-icon>
        </button>
      </div>
    </div>
    
    <!-- Nút thêm ảnh -->
    <div *ngIf="sourceImg != 'device'"
    class="add-image-btn upload-background-image mt-4" (click)="addImage()">
      <p class="add-image-btn_text">{{'them_anh' | translate}}</p>
      <mat-icon class="add-image-btn_icon">{{ iconAddImage[sourceImg] }}</mat-icon>
    
      <div  *ngIf="toggleInputLinkImg">
        <div class="overlay" (click)="closePopover($event)"></div>
    
        <!-- Phần popup để nhập đường dẫn hình ảnh -->
        <div class="popover">
          <p>{{'duong_dan_anh' | translate}}</p>
          <div class="d-flex align-items-center gap-4">
            <input style="flex: 1 0 100px;" class="input mr-1" type="text" [(ngModel)]="newUrlImage"
            placeholder="{{'nhap_duong_dan_lien_ket' | translate}}">
            <span role="button" class="text-success" (click)="handleChangeUrlImage($event)">{{'ap_dung' | translate}}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- Input để upload file hình ảnh -->
    <input type="file" accept="image/*" (change)="onUpload($event)" id="upload" name="file" hidden />
  </div>

  <!-- Cập nhật liên kết -->
  <div style="width: 20%">
    <!-- Nút hướng dẫn lấy link youtube -->
    <button nz-button nzType="primary" (click)="isOpenGuideVideo = true" class="mb-2">
      {{ 'huong_dan_chen_video_youtube' | translate }}
    </button>
    <!-- Đường dẫn video youtube -->
    <div>
      <p class="mb-1">{{'duong_dan_video_youtube' | translate}}</p>
      <input 
        class="input w-100" type="text" [ngModel]="itemEdit.youtube_url ?? ''"
        (ngModelChange)="itemEdit.youtube_url = $event"
        (blur)="onInputBlur('youtube_url')"
        placeholder="https://www.youtube.com/watch?v=HCHHY4qK6uA"
      />
    </div>
    <!-- Vị trí video trong nhóm ảnh sản phẩm -->
    <ng-container *ngIf="itemEdit.youtube_url?.trim()">
      <div class="mt-2">
        <div>
          <label for="name-input">{{'vi_tri_video_trong_nhom_anh_(_danh_sach_anh_nho_)' | translate}}</label>
        </div>
        <div class="layout-input d-flex justify-content-between">
          <nz-select [ngModel]="itemEdit.position_video_youtube || 1"
          (ngModelChange)="itemEdit.position_video_youtube = $event">
            <nz-option [nzLabel]="'vi_tri_dau_tien' | translate" [nzValue]="1"></nz-option>
            <nz-option [nzLabel]="'vi_tri_sau_hinh_dau_tien' | translate" [nzValue]="2"></nz-option>
          </nz-select>
        </div>
      </div>
    </ng-container>
    <hr style="background: #333;" />
    <!-- type-link -->
    <div class="type-link mb-2">
      <p class="type-link__title">{{'cap_nhat_duong_dan_lien_ket' | translate}}</p>
      <nz-select class="type-link__select" [(ngModel)]="itemEdit.type_link"
        (ngModelChange)="getBlocksbyPage()" nzPlaceHolder="{{'chon_kieu_lien_ket' | translate}}"
        allowClear>
        <nz-option *ngFor="let item of type_link" [nzValue]="item.value" nzLabel="{{item.label | translate}}"></nz-option>
      </nz-select>
    </div>

    <!-- ĐẾN TRANG -->
    <div class="connect-page" *ngIf="itemEdit.type_link == 'page_link'">
      <nz-select [(ngModel)]="itemEdit.link" (ngModelChange)="getBlocksbyPage()"
        nzPlaceHolder="{{'chon_trang_lien_ket' | translate}}" allowClear nzShowSearch>
        <nz-option *ngFor="let page of arr_link_page" [nzValue]="page.link"
          [nzLabel]="page['name_' + functionService.selectedLanguageCode] || page.name">
        </nz-option>
      </nz-select>
    </div>

    <!-- LIÊN KẾT ĐIỀU HƯỚNG -->
    <div class="navigation-link" *ngIf="itemEdit.type_link == 'navigation_link'">
      <nz-input-group [nzSuffix]="suffixIconClose">
        <input type="text" nz-input placeholder="/ten-trang-chi-tiet-san-pham/ten-san-pham" [(ngModel)]="itemEdit.link"
          (blur)="getBlocksbyPage()" />
      </nz-input-group>
      <ng-template #suffixIconClose>
        <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('link')"></span>
      </ng-template>
    </div>

    <!-- ĐẾN MAIL -->
    <div class="mail-link" *ngIf="itemEdit.type_link == 'mailto'">
      <nz-input-group [nzSuffix]="suffixIconClose"
        [style.border-color]="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto }) ? 'red' : '#d9d9d9'">
        <input type="text" nz-input placeholder="viethas.info@gmail.com" [(ngModel)]="itemEdit.mailto" />
      </nz-input-group>
      <ng-template #suffixIconClose>
        <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('mailto')"></span>
      </ng-template>
      <p *ngIf="itemEdit.mailto && !isValidValue({ mailto: itemEdit.mailto })" class="text-danger mt-1 pl-2 lh-base">
        {{'email_khong_hop_le' | translate}}
      </p>
    </div>

    <!-- ĐẾN SỐ ĐIỆN THOẠI -->
    <div class="mail-link" *ngIf="itemEdit.type_link == 'tel'">
      <nz-input-group [nzSuffix]="suffixIconClose" [style.border-color]="itemEdit.tel ? 'red' : '#d9d9d9'">
        <input type="text" nz-input placeholder="0909925354" [(ngModel)]="itemEdit.tel" />
      </nz-input-group>
      <ng-template #suffixIconClose>
        <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('tel')"></span>
      </ng-template>
      <p *ngIf="!itemEdit.tel" class="text-danger mt-1 pl-2 lh-base">
        {{'so_dien_thoai_khong_hop_le' | translate}}
      </p>
    </div>

    <!-- Hành động khi nhấn -->
    <div *ngIf="itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link'" class="mt-3">
      <label for="scroll-select">{{'hanh_dong_khi_nhan'| translate}}:</label>
      <br />
      <nz-select id="scroll-select" [(ngModel)]="itemEdit.is_scroll">
        <nz-option *ngFor="let item of clickActionOptions" [nzValue]="item.value"
          [nzLabel]="item.label | translate"></nz-option>
      </nz-select>
    </div>

    <!-- CUỘN ĐẾN BLOCK -->
    <ng-container style="width: 100%"
      *ngIf="(itemEdit.type_link == 'page_link' || itemEdit.type_link == 'navigation_link') && itemEdit.is_scroll == 'scroll_to_block'">
      <nz-select style="margin: 8px 0" [nzPlaceHolder]="'chon_khoi' | translate" [(ngModel)]="itemEdit.scroll_block_id">
        <nz-option *ngFor="let block of blocks_of_page" [nzValue]="block._id"
          [nzLabel]="block.name | translate"></nz-option>
      </nz-select>

      <div class="form-group">
        <label for="scrollDistance">{{'khoang_cach_chua_ra_de_tranh_menu_co_dinh' | translate }}</label>
        <input type="number" nz-input class="field-fill" [(ngModel)]="itemEdit.scroll_distance" />
      </div>
    </ng-container>


    <!-- LIÊN KẾT TRANG KHÁC (URL) -->
    <div class="connect-link" *ngIf="itemEdit.type_link == 'hyper_link'">
      <nz-input-group [nzSuffix]="suffixIconClose">
        <input type="text" nz-input placeholder="https://viethas.com/" [(ngModel)]="itemEdit.hyper_link" />
      </nz-input-group>
      <ng-template #suffixIconClose>
        <span nz-icon nzType="close-circle" class="icon-close" (click)="removeLink('hyper_link')"></span>
      </ng-template>
    </div>
  </div>
</div>

<!-- ------------------------------------------------- HỘP THOẠI HƯỚNG DẪN CHÈN VIDEO -------------------------------------------------- -->
<nz-modal [(nzVisible)]="isOpenGuideVideo" (nzOnCancel)="isOpenGuideVideo = false" [nzFooter]="null"
[nzStyle]="{ height: '500px' }" [nzWidth]="'70%'">
  <ng-container *nzModalContent>
    <div class="d-flex">
      <div style="width: 40%;">
        <h4 class="title">
          {{ 'loai_duong_dan_co_the_su_dung' | translate }}
        </h4>
        <ul class="m-0 pl-4">
          <li>{{ 'co_the_dan_duong_dan_youtube' | translate }}</li>
          <li>{{ 'co_the_dan_duong_dan_nhung_youtube' | translate }}</li>
          <li>{{ 'co_the_dan_ma_nhung_youtube' | translate }}</li>
        </ul>
      </div>
      <div class="modal-success">
        <h4 class="title">
          {{'huong_dan_khach_hang_chen_video_youtube_vao_trang_web' | translate}}
        </h4>
        <span>
          <i class="bi bi-x-lg"></i>
        </span>
        <div class="list-image">
          <div class="item-image">
            <img src="../../../../../../assets/root/images/system/imgs/video_B1.jpg" alt="image 1">
            <div class="note-content">
              {{ 'buoc' | translate }} 1: {{ 'truy_cap_vao_video_tren_youtube_muon_chen_sau_do' | translate }}
              <span style="color:#00a859"> {{ 'nhan_vao' | translate }}
                <span style="font-weight: bold;"> {{ 'nut' | translate}} Share</span>
              </span> {{ 'o_duoi_video' | translate }}.
            </div>
          </div>
          <div class="item-image">
            <img src="../../../../../../assets/root/images/system/imgs/video_b2.jpg" alt="image_2">
            <div class="note-content">
              {{ 'buoc' | translate }} 2: 
              <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{ 'nut' | translate}} Embed</span></span>
              {{ 'de_lay_ma_nhung' | translate }}.
            </div>
          </div>
        </div>
        <div class="list-image pt-2">
          <div class="item-image">
            <img src="../../../../../../assets/root/images/system/imgs/video_b3.jpg" alt="image 3">
            <div class="note-content">
              {{ 'buoc' | translate }} 3: 
              <span style="color:#00a859">{{ 'nhan_vao' | translate }} <span style="font-weight: bold;">{{ 'nut' | translate}} Copy</span></span>,
              {{ 'he_thong_tu_dong_sao_chep_ma_nhung_cua_video' | translate }}.
            </div>
          </div>
          <div class="item-image">
            <img src="../../../../../../assets/root/images/system/imgs/video_b4.jpg" alt="image 4">
            <div class="note-content">
              {{ 'buoc' | translate }} 4: 
              <span style="color:#00a859">{{ 'dan_ma_nhung_vao_o_duong_dan_sau_do_nhan' | translate }} 
                <span style="font-weight: bold;">{{ 'nut_cap_nhat' | translate }}</span> 
              </span> {{ 'de_he_thong_lay_video_tu_youtube_ve' | translate }}.
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</nz-modal>